'use strict';

export var fnEditUser = function () {

    var form = $('#form-update-user-info');

    form.submit(function (e) {
        e.preventDefault();

        const formData = form.serialize();

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: formData,
            success: function (response) {
                toastr.success(response.success);

                if (response.reload) {
                    window.location.reload(true);
                }
            },
            error: function (data) {
                if(data.status === 409)return;
                var errors = '';
                for (var datos in data.responseJSON.errors) {
                    errors += data.responseJSON.errors[datos] + '<br>';
                }
                if (errors) {
                    toastr.error(errors);
                }
            }
        });


    });
};